import styled from 'styled-components';

export const StyledTitle = styled.h1`
    font-family: var(--headings-font-family);
    font-size:2rem;
    font-weight: 600;
    background: linear-gradient(to right, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);
    -webkit-text-fill-color: transparent; /* Safari */
    text-fill-color: transparent;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: linear-gradient(to right, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);
    top: 0;
    margin: 0 auto;
    text-align: center;
    padding: 1rem;
;`

